export const convertMinsToHrsMins = (mins) => {
  let h = Math.floor(mins / 60) as any;
  let m = mins % 60 as any;
  h = h < 10 ? '0' + h : h;
  m = m < 10 ? '0' + m : m;
  return `${h}:${m}`;
};
